// Este codigo fue generado por Github Copilot Chat
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleButtonComponent } from './atoms/toggle-button/toggle-button.component';
import { LoadingSpinnerComponent } from './atoms/loading-spinner/loading-spinner.component';
import { SelectComponent } from './molecules/select/select.component';
import { ButtonComponent } from './molecules/button/button.component';
import { InputTextComponent } from './molecules/input-text/input-text.component';
import { InputTextAreaComponent } from './molecules/input-text-area/input-text-area.component';
import { InputCheckComponent } from './molecules/input-check/input-check.component';
import { InputSearchComponent } from './molecules/input-search/input-search.component';
import { InputFileComponent } from './molecules/input-file/input-file.component';
import { AppDatePickerComponent } from './molecules/app-date-picker/app-date-picker.component';
import { ModalComponent } from './molecules/modal/modal.component';
import { AvatarComponent } from './molecules/avatar/avatar.component';
import { SuraAvatarCollapsibleComponent } from './molecules/sura-avatar-collapsible/sura-avatar-collapsible.component';
import { TableComponent } from './molecules/app-table/app-table.component';
import { PaginatorComponent } from './molecules/paginator/paginator.component';
import { DropdownComponent } from './molecules/dropdown/dropdown.component';
import { StepByStepComponent } from './molecules/step-by-step/step-by-step.component';
import { TabComponent } from './molecules/tab/tab.component';
import { DisplayAvatarListComponent } from './molecules/display-avatar-list/display-avatar-list.component';

/**
 * Array de componentes compartidos para evitar duplicación
 * en imports y exports del módulo
 */
const SHARED_UI_COMPONENTS = [
  ToggleButtonComponent,
  LoadingSpinnerComponent,
  SelectComponent,
  ButtonComponent,
  InputTextComponent,
  InputTextAreaComponent,
  InputCheckComponent,
  InputSearchComponent,
  InputFileComponent,
  AppDatePickerComponent,
  ModalComponent,
  AvatarComponent,
  SuraAvatarCollapsibleComponent,
  TableComponent,
  PaginatorComponent,
  DropdownComponent,
  StepByStepComponent,
  TabComponent,
  DisplayAvatarListComponent
];

@NgModule({
  imports: [CommonModule, ...SHARED_UI_COMPONENTS],
  exports: SHARED_UI_COMPONENTS
})
export class SuraUiModule {}
// Este codigo fue generado por Github Copilot Chat
